module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/help-to-buy-wales-e8791527c8624527409fa8559c37d4a6.jpg";